import { PlanGroupType, PlanSubGroupType } from 'core/constants';
import { ModelBase } from 'store/model-base';

export class PlanPromoSubGroup extends ModelBase {

    public planType: PlanGroupType;
    public planSubgroup: PlanSubGroupType;
    public originalMonthlyCost: number;
    public costAfterServicePromo: number;
}